<template>
  <div class="whole">
    <div class="breadcrumbs flex ai">
      <div @click="router.push('/')" class="breadcrumbs-txt pointer">主页</div>
      <img class="iconArrow" src="@/assets/iconArrow.png" alt="" />
      <div class="breadcrumbs-txt1 default">联系我们 Contact Us</div>
    </div>
    <div class="main-content flex column jcs">
      <div style="padding: 1.02rem 2.75rem 0.48rem 2.75rem; box-sizing: border-box">
        <div class="contact-us-container">
          <div class="container-h1">拜耳医药保健有限公司</div>
          <div class="container-txt" style="margin-top: 0.3rem">公司总机：+8610 5921 8282</div>
          <div class="container-txt" style="margin-top: 0.4rem">中国北京市朝阳区东三环北路27号拜耳中心</div>
          <div class="container-txt">邮编：100020</div>
          <div class="container-txt">电话：+86-10-59218282</div>
          <div class="container-h1" style="margin-top: 0.56rem">拜耳医药保健有限公司</div>
          <div class="container-txt" style="margin-top: 0.29rem">中国（上海）自由贸易试验区海阳西路399号浅滩时代广场第10层（实际楼层第9层）1001A单元</div>
          <div class="container-txt">邮编：200120</div>
          <div class="container-txt">电话：+86-21-61468282</div>
          <div class="container-txt">如需咨询拜耳产品相关的问题，您可以通过以下电话联系我们：</div>
          <div class="container-txt">热线：400-810-0360（手机座机均可拨打）</div>
          <div class="container-txt">我们会尽力解答您关于拜耳产品的相关咨询，但我们无法对患者目前的病情提出具体诊疗建议。如果您用药后出现不适，请务必及时就医。</div>
          <div class="container-txt">如需报告使用拜耳产品后出现的不适或产品质量问题，可与您的医生药师或本地药品监管部门进行联系，也可通过以下方式直接联系我们。</div>
          <div class="container-txt">邮箱：AE_China@bayer.com</div>
          <div class="container-txt">媒体相关问讯：请传真至+8610 8550 5176</div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script setup>
import Footer from "../../components/Footer.vue";
import { useRouter } from "vue-router";
const router = useRouter();
</script>

<style src="./contactUs.css" scoped></style>
